import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountSentimentReportAverageSummaryApplicationService } from '../../../core/application/services/sentiment/get-account-sentiment-report-average-summary.application-service';
import { AccountSentimentReportAverageSummaryAggregateRoot } from '../../../core/domain/aggregates/sentiment/account-sentiment-report-average-summary.aggregate-root';
import { GetAccountSentimentReportAverageSummaryRequestDto } from '../../dtos/sentiment/get-account-sentiment-report-average-summary.request.dto';

export class GetAccountSentimentReportAverageSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetAccountSentimentReportAverageSummaryApplicationService
  ) {}
  async execute(
    props: GetAccountSentimentReportAverageSummaryRequestDto
  ): Promise<AccountSentimentReportAverageSummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
